module.exports = __webpack_public_path__ + "static/media/parceiro-sensedia-07.fe4c738d.webp";